import { useCallback, useEffect, useRef, useState } from 'react';
import { notification } from '@spark/ui-components/utils/notification';
import { getMetabaseDashboardToken } from '@spark/services/metabase';

export const useMetabaseDashboardToken = (dashboardId) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getMetabaseDashboardToken(dashboardId);
      const payload = response?.data || response || {};

      if (!payload?.token || !payload?.instanceUrl) {
        throw new Error('Resposta invalida ao obter token do Metabase.');
      }

      if (!isMountedRef.current) return;
      setData(payload);
    } catch (err) {
      if (!isMountedRef.current) return;
      const message = err?.response?.data?.error || err?.message || 'Erro ao carregar dashboard';
      notification.error(message);
      setError(message);
      setData(null);
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  }, [dashboardId]);

  useEffect(() => {
    load();
  }, [load]);

  return { loading, data, error, reload: load };
};

